<!--首页 金额统计图标-->
<template>
    <div v-loading="loading" 
        element-loading-text="正在加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(23, 40, 90)" ref="monthMoneyEcharts" style="width:100%;height:100%;" class="center" />
</template>

<script>
import { mapState } from "vuex";
import Public from "@/public";
var echarts = require("echarts");
export default {
    data() {
        return {
            loading: true,
            orderSummaryDatas: null,
            axisData: [],
            moneyData: [],
            powerData: [],
            chart: null,
        };
    },
    watch: {
        monthOrderSummary: {
            handler(val) {
                console.log(val)
                this.orderSummaryDatas = JSON.parse(JSON.stringify(val));
                this.axisData = [];
                this.moneyData = [];
                this.powerData = [];
                this.dealMonthData(this.orderSummaryDatas);
            },
            deep: true,
        },
        axisData: {
            handler(val) {
                if (val) {
                    this.dataEcharts();
                }
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["theme", "monthOrderSummary"]),
    },
    mounted() {
        this.chart = echarts.init(this.$refs.monthMoneyEcharts);
    },
    props: {},
    methods: {
        dataEcharts() {
            this.chart.setOption({
                title: {
                    // text: "营业额-电量",
                    // left: "6%",
                    // top: "0.1%",
                    // textStyle: {
                    //     color: this.theme.pageFontColor,
                    // },
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                    },
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                toolbox: {
                    right: "5%",
                    feature: {
                        // dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ["line", "bar", "pie"] },
                        // restore: { show: true },
                        saveAsImage: { show: true },
                    },
                },
                legend: {
                    data: ["营业额", "电量"],
                    top: 30,
                },
                xAxis: [
                    {
                        type: "category",
                        axisTick: {
                            alignWithLabel: true,
                        },
                        data: this.axisData,
                        axisLabel: {
                            margin: 34,
                            top: "10%",
                            textStyle: {
                                color: "#97a0d3",
                                align: "center",
                                fontSize: "15",
                                verticalAlign: "middle",
                                lineHeight: 40,
                                top: "10%",
                            },
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "营业额",
                        // min: 0,
                        position: "left",
                        // interval: 100000,
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            formatter: "{value} 元",
                            textStyle: {
                                color: "#00abf5",
                            },
                        },
                    },
                    {
                        type: "value",
                        name: "电量",
                        // min: 0,
                        position: "right",
                        // interval: 100000,
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            formatter: "{value} KW·H",
                            textStyle: {
                                color: "#00abf5",
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: "营业额",
                        type: "line",
						smooth: true,
                        yAxisIndex: 0,
                        data: this.moneyData,
                        // markPoint: {
                        //     data: [
                        //         { type: "max", name: "最大值" },
                        //         { type: "min", name: "最小值" },
                        //     ],
                        // },
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                            label: {
                                position: "start",
                            },
                        },
                    },
                    {
                        name: "电量",
                        type: "line",
                        yAxisIndex: 1,
						smooth: true,
                        data: this.powerData,
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" },
                            ],
                        },
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                            label: {
                                position: "start",
                            },
                        },
                    },
                ],
            });
            this.loading = false;
        },
        //处理获取到的每个月的数据
        dealMonthData(orderSummary) {
            if (!orderSummary) {
                return;
            }
            orderSummary.sort(Public.createComprisonFunction("sum_date"));
            for (let i = 0; i < orderSummary.length; i++) {
                let data = JSON.parse(JSON.stringify(orderSummary[i]));
                this.axisData.push(data.sum_date);
                this.moneyData.push(data.money.toFixed(2));
                this.powerData.push(data.power.toFixed(2));
            }
            this.dataEcharts();
        },
    },
};
</script>
<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
